import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import ProcessedSocialMediaAccount from './processed-social-media-account-model'
import {
  CreateProcessedSocialMediaAccountAsync,
  DeleteProcessedSocialMediaAccountAsync,
  LoadProcessedSocialMediaAccountsAsync,
} from './processedSocialMediaAccount-thunk'
const initialState: processedSocialMediaAccountSliceState = {
  processedSocialMediaAccount: [],
  selected_processedSocialMediaAccount: '',
  is_loading_processedSocialMediaAccount: false,
  is_creating_processedSocialMediaAccount: false,
  is_deleting_processedSocialMediaAccount: false,
}
export interface processedSocialMediaAccountSliceState {
  processedSocialMediaAccount: ProcessedSocialMediaAccount[]
  selected_processedSocialMediaAccount?: string
  is_loading_processedSocialMediaAccount: boolean
  is_creating_processedSocialMediaAccount: boolean
  is_deleting_processedSocialMediaAccount: boolean
}
export const processedSocialMediaAccountSlice = createSlice({
  name: 'processedSocialMediaAccount',
  initialState,
  reducers: {
    setSelectedprocessedSocialMediaAccount: (state, action) => {
      state.selected_processedSocialMediaAccount = action.payload
    },
    clearStateprocessedSocialMediaAccount: (state) => {
      state.processedSocialMediaAccount = []
      state.is_loading_processedSocialMediaAccount = false
      state.is_creating_processedSocialMediaAccount = false
      state.is_deleting_processedSocialMediaAccount = false
    },
    mergeprocessedSocialMediaAccount: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_processedSocialMediaAccount = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.processedSocialMediaAccount = merge(
            state.processedSocialMediaAccount,
            payload,
          ) as any
        }
      }
    },

    add_processedSocialMediaAccount: (state, action) => {
      if (action.payload) {
        state.processedSocialMediaAccount = [
          ...state.processedSocialMediaAccount,
          action.payload,
        ]
      }
    },
    set_processedSocialMediaAccount: (state, action) => {
      let { key, value, id } = action.payload
      state.processedSocialMediaAccount = state.processedSocialMediaAccount.map(
        (item) => {
          if (item && item.id === id) {
            return {
              ...item,
              [key]: value,
            }
          }
          return item
        },
      )
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadProcessedSocialMediaAccountsAsync.pending, (state) => {
      state.is_loading_processedSocialMediaAccount = true
    })
    builder.addCase(
      LoadProcessedSocialMediaAccountsAsync.fulfilled,
      (state, action) => {
        state.is_loading_processedSocialMediaAccount = false
        if (action.payload) {
          state.processedSocialMediaAccount = action.payload
        }
      },
    )
    builder.addCase(LoadProcessedSocialMediaAccountsAsync.rejected, (state) => {
      state.is_loading_processedSocialMediaAccount = false
    })
    builder.addCase(CreateProcessedSocialMediaAccountAsync.pending, (state) => {
      state.is_creating_processedSocialMediaAccount = true
    })
    builder.addCase(
      CreateProcessedSocialMediaAccountAsync.fulfilled,
      (state) => {
        state.is_creating_processedSocialMediaAccount = false
      },
    )
    builder.addCase(
      CreateProcessedSocialMediaAccountAsync.rejected,
      (state) => {
        state.is_creating_processedSocialMediaAccount = false
      },
    )
    builder.addCase(DeleteProcessedSocialMediaAccountAsync.pending, (state) => {
      state.is_deleting_processedSocialMediaAccount = true
    })
    builder.addCase(
      DeleteProcessedSocialMediaAccountAsync.fulfilled,
      (state, action) => {
        state.is_deleting_processedSocialMediaAccount = false
        if (state.processedSocialMediaAccount) {
          state.processedSocialMediaAccount =
            state.processedSocialMediaAccount.filter(
              (x) => action.payload.id !== x.id,
            )
        }
      },
    )
    builder.addCase(
      DeleteProcessedSocialMediaAccountAsync.rejected,
      (state) => {
        state.is_deleting_processedSocialMediaAccount = false
      },
    )
  },
})

export const {
  clearStateprocessedSocialMediaAccount,
  setSelectedprocessedSocialMediaAccount,
  set_processedSocialMediaAccount,
  mergeprocessedSocialMediaAccount,
  add_processedSocialMediaAccount,
} = processedSocialMediaAccountSlice.actions

export const get_processedSocialMediaAccount =
  (id?: string) =>
  (state: {
    processedSocialMediaAccount: {
      processedSocialMediaAccount: ProcessedSocialMediaAccount[]
    }
  }): ProcessedSocialMediaAccount | null => {
    let temp =
      state?.processedSocialMediaAccount?.processedSocialMediaAccount?.find(
        (v) => v.id === id,
      )
    if (temp) {
      return temp
    }
    return (
      state?.processedSocialMediaAccount?.processedSocialMediaAccount[0] || null
    )
  }
export const get_selected_processedSocialMediaAccount = (state: {
  processedSocialMediaAccount: processedSocialMediaAccountSliceState
}): ProcessedSocialMediaAccount | null => {
  let id =
    state?.processedSocialMediaAccount?.selected_processedSocialMediaAccount
  let temp =
    state?.processedSocialMediaAccount?.processedSocialMediaAccount?.find(
      (v) => v.id === id,
    )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_processedSocialMediaAccount = (state: {
  processedSocialMediaAccount: {
    processedSocialMediaAccount: ProcessedSocialMediaAccount[]
  }
}): ProcessedSocialMediaAccount[] => {
  let temp = state?.processedSocialMediaAccount?.processedSocialMediaAccount
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_processedSocialMediaAccount_busy = (state: {
  processedSocialMediaAccount: processedSocialMediaAccountSliceState
}) => {
  return (
    state?.processedSocialMediaAccount
      .is_deleting_processedSocialMediaAccount ||
    state?.processedSocialMediaAccount.is_loading_processedSocialMediaAccount ||
    state?.processedSocialMediaAccount.is_creating_processedSocialMediaAccount
  )
}
export const is_deleting_processedSocialMediaAccount_busy = (state: {
  processedSocialMediaAccount: processedSocialMediaAccountSliceState
}) => {
  return state?.processedSocialMediaAccount
    .is_deleting_processedSocialMediaAccount
}
export const is_loading_processedSocialMediaAccount_busy = (state: {
  processedSocialMediaAccount: processedSocialMediaAccountSliceState
}) => {
  return state?.processedSocialMediaAccount
    .is_loading_processedSocialMediaAccount
}
export const is_creating_processedSocialMediaAccount_busy = (state: {
  processedSocialMediaAccount: processedSocialMediaAccountSliceState
}) => {
  return state?.processedSocialMediaAccount
    .is_creating_processedSocialMediaAccount
}

export default processedSocialMediaAccountSlice.reducer
